var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"badge badge-success",staticStyle:{"font-size":"11px","opacity":"1"}},[_vm._v("EARLY ACCESS")])
}
var staticRenderFns = []

export { render, staticRenderFns }